import React, { useState, useEffect, useContext } from "react";
import classes from "../../TrucksAvailable.module.css";
import {
  isMobile,
  Activity,
  currentRequestTimeStamp,
  NegotiateDateFormatter,
} from "../../../../Constants";
import { Urls } from "../../../../Urls";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";

import Timeline from "./Timeline/Timeline";
import ProfileModal from "../../../TransporterClientScreen/ProfileModal/ProfileModal";
import { checkModuleAccess } from "../../../../Utility";
import axios from "../../../../Axios";
import Loader from "../../../Loader";
import { AlertPopup } from "../../../Shared/AlertPopup/AlertPopup";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import useViewOnlyAccess from "../../../../hooks/useViewOnlyAccess";
import CountdownTimer from "../CountdownTimer";
import ConfirmDialog from "../../../Shared/ConfirmDialog2/ConfirmDialog";

const Summary = ({
  enquiryTransition,
  // transporter_list,
  item,
  emailTemplate,
  // userid,
  itemdisable = false,
  isApprover = false,
  approval_type = "enquiry",
  autoPushIndent = false,
  companyProfile = {},
  approverList = [],
  //isRestricted,
  onSuccess,
}) => {
  const [interestedlist, setList] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const [rank_list, setRank_list] = useState([]);
  const [total_quotes_count, setTotal_quotes_count] = useState(0);
  const [errorInAcceptance, setErrorInAcceptance] = useState(false);
  const [acceptedRejectedData, setAcceptedRejectedData] = useState({});
  const [updatedRateList, setUpdatedRateList] = useState([]);
  // const [remark, setRemark] = useState('');
  const [show, setshow] = useState(false);
  const [remarkDisable, setremarkDisable] = useState(false);
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  const [benchmark_list, setBenchmark_list] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', message: null, onConfirm: () => { }, confirmText: 'Confirm', variant: 'default' });
  const [rateChangedDialog, setRateChangedDialog] = useState(false);
  const [rateChangedDialogData, setRateChangedDialogData] = useState({
    title: "Rate Has Been Updated",
    message: "The rate has been changed by the transporter. Please refresh to see the latest rates before taking action."
  });
  const [isIndentCreated, setIsIndentCreated] = useState(false);
  var company_name = localStorage.getItem("companyname");
  var company_mail = localStorage.getItem("useremail");
  var user_name = localStorage.getItem("userdetails");
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );
  const { isRestricted } = useViewOnlyAccess("spot");
  const isMandatoryApprovalRemark = companySettingData?.enquiry?.mandatory_approval_remark === true;
  const isNegotiateAfterNoRegret = companySettingData?.enquiry?.negotiate_after_no_regret === true;
  const isPostExpiryAcceptanceEnabled =
    companySettingData?.enquiry?.post_expiry_acceptance === true;
  const isPostExpiryAcceptanceFlow =
    item?.status?.is_expired === true && isPostExpiryAcceptanceEnabled;
  const isExpiredAcceptanceBlocked =
    item?.status?.is_expired === true && !isPostExpiryAcceptanceEnabled;
  const isEnquiryApproved =
    item?.main_status === "approved" ||
    item?.status?.approved_status === "approved" ||
    (interestedlist && interestedlist.some(t =>
      t.main_status === "approved" ||
      (t.rate_list && t.rate_list.length > 0 && t.rate_list[t.rate_list.length - 1].main_status === "approved") ||
      (t.rate_list && t.rate_list.length > 0 && t.rate_list[t.rate_list.length - 1].bid_status === "approved")
    )) ||
    isIndentCreated ||
    item.indent_created === true;

  useEffect(() => {
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on view quotation button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    // mixpanel.track(`User has clicked on view quotation button`, {
    //   ApplicationName: `${Urls.mixpanelappname}`,
    //   ScreenName: "LoRRI-Trucksavailable",
    //   ModuleName: "my_enquiries",
    //   ActivityLog: "userClickedViewQuotationButton",
    //   Data: `${item.origin.location_name} to ${
    //     item.destination.location_name
    //   }, ${
    //     Array.isArray(item.truck_types) ? (
    //       <>
    //         {" "}
    //         {item.truck_types && item.truck_types.length > 0
    //           ? item.truck_types.map((trucks) => {
    //               return trucks.label;
    //             })
    //           : null}{" "}
    //       </>
    //     ) : (
    //       item.truck_types.label
    //     )
    //   }`,
    //   Definition: `User has clicked on view quotation button`,
    //   ActivityType: "event_view",
    //   UserName: `${localStorage.getItem("userdetails")}`,
    //   UserEmail: `${localStorage.getItem("useremail")}`,
    //   CompanyName: `${localStorage.getItem("companyname")}`,
    // });

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user viewed quotation summary modal`,
    });

    fetchSummary();
  }, []);

  const fetchSummary = () => {
    var interested = [];
    var rate_list = [];
    setshow(true);

    if (item && item.truck_enquiry_id) {
      axios
        .get(`${Urls.spot}?field=view_quotations&truck_enquiry_id=${item.truck_enquiry_id}`)
        .then((res) => {
          const indentInfo = Array.isArray(res.data) ? res.data.find(obj => obj && obj.hasOwnProperty('indent_created')) : null;
          if (indentInfo) {
            setIsIndentCreated(indentInfo.indent_created);
          }
          let transporterList = res.data;
          if (Array.isArray(transporterList)) {
            transporterList = transporterList.filter(t => t && t.transporter_id);
          }
          if (transporterList && transporterList.length > 0) {
            transporterList = transporterList.map((t) => {
              if (t.rate_list) {
                t.rate_list = t.rate_list.map((rateItem) => {
                  if (rateItem.status && !rateItem.bid_status) {
                    return { ...rateItem, bid_status: rateItem.status };
                  }
                  return rateItem;
                });
              }
              return t;
            });

            setnewtransporter_list(transporterList);
            const transporterRateCounts = transporterList.map((t) => ({
              transporter_id: t.transporter_id || "",
              rate_list_count: t.rate_list?.length || 0,
            }));
            setTotal_quotes_count(transporterRateCounts);
            setBenchmark_list(item.benchmark_transporter_list || []);
            transporterList.forEach((transporter) => {
              rate_list.push(parseInt(transporter.rate));
              transporter.show_history = false;
              transporter.remark = ""; // Add a "remark" property to each transporter
              if (
                transporter.rate_list &&
                transporter.rate_list.length > 0 &&
                transporter.rate_list[transporter.rate_list.length - 1]
                  .bid_status === "negotiated"
              ) {
                transporter.rate_list[
                  transporter.rate_list.length - 1
                ].change = true;
              }
              interested.push(transporter);
            });
            setRank_list([...new Set(rate_list)]);
            setList(interested);
          } else {
            setList([]);
            setnewtransporter_list([]);
          }
          setshow(false);
        })
        .catch((err) => {
          console.error(err);
          setshow(false);
        });
    } else {
      setshow(false);
    }
  };

  /**
   * Handles the click event for a transporter, updating the interested list with a negotiated rate.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const clickHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    if (isPostExpiryAcceptanceFlow) {
      toast.info("Counter offer is not allowed for expired enquiry.");
      return;
    }
    var temp = interestedlist.slice();
    if (temp && temp.length > 0) {
      temp.map((t) => {
        if (t.transporter_id === transporter.transporter_id) {
          t.negotiated_rate = t.rate;
          t.rate_list.push({ bid_status: "negotiated" });
        }
      });
    }
    setList(temp);
  };

  /**
   * Edits the negotiated rate for a transporter in the new transporter list.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const editnegrate = (transporter) => {
    var temp = newtransporter_list.slice();
    if (temp && temp.length > 0) {
      temp.map((t) => {
        if (t.transporter_id === transporter.transporter_id) {
          t.negotiated_rate =
            t.rate_list[t.rate_list.length - 1] &&
              t.rate_list[t.rate_list.length - 1].negotiated_rate
              ? t.rate_list[t.rate_list.length - 1].negotiated_rate
              : t.rate;
          t.rate_list[t.rate_list.length - 1].change = false;
        }
      });
    }
    setList(temp);
  };

  /**
   * Increases the negotiated rate for a transporter by 500.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const addHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    var temp = interestedlist.slice();
    if (temp && temp.length > 0) {
      temp.map((t) => {
        if (t.transporter_id === transporter.transporter_id) {
          t.negotiated_rate = parseInt(t.negotiated_rate) + 500;
        }
      });
    }
    setList(temp);
  };

  /**
   * Decreases the negotiated rate for a transporter by 500, ensuring it doesn't go below 0.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const substractHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    var temp = interestedlist.slice();
    if (temp && temp.length > 0) {
      temp.map((t) => {
        if (t.transporter_id === transporter.transporter_id) {
          if (parseInt(t.negotiated_rate) - 500 > 0) {
            t.negotiated_rate = parseInt(t.negotiated_rate) - 500;
          }
        }
      });
    }
    setList(temp);
  };

  /**
   * Handles input change for the negotiated rate of a transporter.
   *
   * @param {Object} e - The event object from the input change.
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   * @param {number} index - The index of the transporter in the list.
   */
  const inputChangeHandler = (e, transporter, index) => {
    transporter.negotiated_rate = e.target.value;
  };





  /**
   * Handles the input change event for the transporter's remark.
   *
   * @param {Object} e - The event object from the input change event.
   * @param {Object} transporter - The transporter object that is being updated.
   * @param {number} transporterIndex - The index of the transporter in the list.
   */
  const handleInputChange = (e, transporter, transporterIndex) => {
    transporter.remark = e.target.value;
  };

  const createIndent = (res, item, type) => {
    const current_enquiry =
      res.data.enquiry_lane_details &&
      res.data.enquiry_lane_details.filter(
        (enquiry) => enquiry.display_adhoc_id === item.display_adhoc_id,
      );
    let current_indent_transporters = [];
    if (type === "approved") {
      current_indent_transporters =
        current_enquiry && current_enquiry.length > 0
          ? current_enquiry[0].transporter_list.filter((transporter) => {
            if (transporter.main_status === "approved" || (transporter.rate_list && transporter.rate_list.some(rate => rate.bid_status === "approved"))) {
              transporter["is_shortlist"] = true;
              return transporter;
            }
          })
          : [];
    } else if (type === "accepted") {
      current_indent_transporters =
        current_enquiry && current_enquiry.length > 0
          ? current_enquiry[0].transporter_list.filter((transporter) => {
            // Check if any rate in rate_list has bid_status 'accepted'
            const hasAcceptedBid = transporter.rate_list.some(
              (rate) => rate.bid_status === "accepted",
            );

            if (hasAcceptedBid) {
              transporter["is_shortlist"] = true; // Mark transporter as shortlisted
              return true; // Include this transporter in the filtered list
            }

            return false; // Exclude transporter if no accepted bid
          })
          : [];
    }
    const indent = {
      truck_enquiry_id: item.truck_enquiry_id,
      indent_created: true,
    };
    if (current_indent_transporters && current_indent_transporters.length > 0) {
      if (
        companyProfile &&
        companyProfile.indent &&
        companyProfile.indent.indent_expiry &&
        companyProfile.indent.indent_auto_expiry_enable === "yes"
      ) {
        const expiryhours = companyProfile.indent.indent_expiry;
        let date = new Date();
        const expirydate = new Date();
        const hr = expirydate.getHours();
        expirydate.setHours(hr + parseInt(expiryhours));
        const day = expirydate.getDate();
        date = ("0" + expirydate.getDate()).slice(-2);
        const month = ("0" + (expirydate.getMonth() + 1)).slice(-2);
        const year = expirydate.getFullYear();
        const final_hr = ("0" + expirydate.getHours()).slice(-2);
        const min = ("0" + expirydate.getMinutes()).slice(-2);
        const sec = ("0" + expirydate.getSeconds()).slice(-2);
        const expiry_date = `${year}-${month}-${day} ${final_hr}:${min}:${sec}.000000`;
        const shortlistedWithRank = (current_indent_transporters || [])
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));
        let newindents;
        if (item && item.from && item.from === "planning") {
          newindents = [
            {
              destination: item.lane_details?.destination,
              expiry_date: expiry_date,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRank,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              load_id: item.load_id,
              truck_id: item.truck_id,
              from: item.from,
              plan_type: item.plan_type,
              lane: `${item.lane_details?.origin.location_name}-${item.lane_details?.destination.location_name}-${item.lane_details?.due_date}`,
            },
          ];
        } else {
          newindents = [
            {
              destination: item.lane_details?.destination,
              expiry_date: expiry_date,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRank,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              from: "adhoc",
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              document_details: item.lane_details?.document_details,
            },
          ];
        }
        // Frontend createIndent is moved to backend. Keep old logic for reference.
        // axios
        //   .post(Urls.createIndent, { indents: newindents })
        //   .then((res) => {
        //     toast.success("Indents floated successfully");
        //     axios
        //       .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
        //       .then(() => setshow(false))
        //       .catch((e) => console.log(e));
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //     setshow(false);
        //   });
        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indents floated successfully");
            setshow(false);
            if (onSuccess) onSuccess();
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
      } else {
        let newindent;
        const shortlistedWithRankNoExpiry = (current_indent_transporters || [])
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));
        if (item && item.from && item.from === "planning") {
          newindent = [
            {
              destination: item.lane_details?.destination,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRankNoExpiry,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              load_id: item.load_id,
              truck_id: item.truck_id,
              from: item.from,
              plan_type: item.plan_type,
              lane: `${item.lane_details?.origin.location_name}-${item.lane_details?.destination.location_name}-${item.lane_details?.due_date}`,
            },
          ];
        } else {
          newindent = [
            {
              destination: item.lane_details?.destination,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRankNoExpiry,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              from: "adhoc",
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              document_details: item.lane_details?.document_details,
            },
          ];
        }
        // Frontend createIndent is moved to backend. Keep old logic for reference.
        // axios
        //   .post(Urls.createIndent, { indents: newindent })
        //   .then((res) => {
        //     toast.success("Indents floated successfully");
        //     axios
        //       .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
        //       .then(() => setshow(false))
        //       .catch((e) => console.log(e));
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //     setshow(false);
        //   });
        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indents floated successfully");
            setshow(false);
            if (onSuccess) onSuccess();
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
      }
    }
  };
  /**
   * Handles the acceptance or rejection of a quotation.
   *
   * @param {Object} transporter - The transporter object associated with the quotation.
   * @param {string} value - The action to be performed ('accepted' or 'rejected').
   *
   * @throws {Error} Throws an error if there is an issue with API requests or other operations.
   */
  const acceptrejectHandler = (
    transporter,
    value,
    isConfirmWindowRequired = true,
  ) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    const isPostExpiryAcceptanceEnabled =
      companySettingData?.enquiry?.post_expiry_acceptance === true;

    if (
      value === "accepted" &&
      item?.status?.is_expired === true &&
      !isPostExpiryAcceptanceEnabled
    ) {
      toast.info("Enquiry Expired");
      return;
    }
    if (isPostExpiryAcceptanceFlow && value === "rejected") {
      toast.info("Reject is not allowed for expired enquiry.");
      return;
    }
    setAcceptedRejectedData({ transporter: transporter, value: value });

    // Mandatory remark check for non-L1 acceptance
    // Fires only on first click (isConfirmWindowRequired=true), not on confirm callback
    if (value === "accepted" && isConfirmWindowRequired && isMandatoryApprovalRemark) {
      const sortedByRate = interestedlist
        .filter(t => t.rate !== undefined && t.rate !== null)
        .slice()
        .sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate));

      const transporterRank = sortedByRate.findIndex(
        t => t.transporter_id === transporter.transporter_id
      );

      // index 0 = L1; anything above = L2, L3, ... → remark is mandatory
      if (transporterRank > 0 && (!transporter.remark || transporter.remark.trim() === "")) {
        const rankLabel = `L${transporterRank + 1}`;
        toast.error(
          `Remark is mandatory for (${rankLabel}). Please add a remark before proceeding.`
        );
        return;
      }
    }

    if (isConfirmWindowRequired) {
      const isAccept = value === 'accepted';
      setConfirmDialog({
        isOpen: true,
        title: isAccept ? (isApprover ? 'Approve Quotation?' : 'Accept Quotation?') : 'Reject Quotation?',
        message: (
          <span>
            Are you sure you want to{' '}
            <strong style={{ color: isAccept ? '#1cc88a' : '#e74a3b' }}>
              {isAccept ? (isApprover ? 'approve' : 'accept') : 'reject'}
            </strong>{' '}
            the quotation of{' '}
            <strong style={{ color: '#393185' }}>{transporter.transporter_name}</strong>?
          </span>
        ),
        confirmText: isAccept ? (isApprover ? 'Yes, Approve' : 'Yes, Accept') : 'Yes, Reject',
        variant: isAccept ? 'success' : 'danger',
        onConfirm: () => acceptrejectHandler(transporter, value, false),
      });
      return;
    }
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on ${value} button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label},
        transporter name: ${transporter?.transporter_name}, transporter id: ${transporter?.transporter_id}, transporter rate: ${transporter?.rate}`,
      Definition: `user has clicked on ${value === "accepted" ? (isApprover ? "approve" : "accept") : "reject"
        } enquiry button`,
    });

    setremarkDisable(true);
    let total_rates = total_quotes_count.reduce(
      (sum, t) => sum + t.rate_list_count,
      0,
    );

    const bidStatus = (value === "accepted" && isApprover) ? "approved" : value;

    let payload;
    if (value === "accepted") {
      if (approval_type === "bulk" && !isApprover) {
        payload = {
          truck_enquiry_id: item.truck_enquiry_id,
          transporter_id: transporter.transporter_id,
          rate: transporter.rate,
          total_quotes_count: total_rates,
          quot_type: transporter.quot_type || null,
          bid_status: bidStatus,
          approver: false,
          mode: "enquiry_level",
          remark: transporter.remark || "",
        };
      } else {
        payload = {
          truck_enquiry_id: item.truck_enquiry_id,
          transporter_id: transporter.transporter_id,
          rate: transporter.rate,
          total_quotes_count: total_rates,
          quot_type: transporter.quot_type || null,
          bid_status: bidStatus,
          approver: isApprover,
          mode: "enquiry_level",
          remark: transporter.remark || "",
        };
      }
    } else {
      payload = {
        truck_enquiry_id: item.truck_enquiry_id,
        transporter_id: transporter.transporter_id,
        rate: transporter.rate,
        total_quotes_count: total_rates,
        quot_type: transporter.quot_type || null,
        bid_status: bidStatus,
        approver: isApprover,
        mode: "enquiry_level",
        remark: transporter.remark || "",
      };
    }

    axios
      .put(
        `${Urls.spot}?edit_bid_status_v2=${value}&force_update=${!isConfirmWindowRequired}&field=logistics_enquiry`,
        payload,
      )
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.status &&
          (res.data.status === "update_failed" || res.data.status === "Failed")
        ) {
          if (
            res.data.new_updates === true ||
            res.data.new_updates === "true"
          ) {
            if (
              res.data.rate_update_status &&
              res.data.rate_update_status.length > 0
            ) {
              setUpdatedRateList(res.data.rate_update_status);
            }
            setErrorInAcceptance(true);
          } else {
            if (res.data.message === "the client has been updated the rate. Please refresh the page") {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "the client has been updated the rate. Please refresh the page",
                showConfirm: false,
                cancelText: "Close"
              });
            } else if (res.data.message === "Spot has been expired") {
              setRateChangedDialogData({
                title: "Spot Expired",
                message: "Spot has been expired",
                showConfirm: false,
                cancelText: "Close"
              });
            } else {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "The transporter has updated the rate. Please refresh the page to see the latest rate before taking any action.",
                showConfirm: true,
                confirmText: "Refresh Now",
                cancelText: "Cancel"
              });
            }
            setRateChangedDialog(true);
          }
          setshow(false);
        } else {
          if (onSuccess) onSuccess();
          if (value === "accepted") {
            toast.success(
              isApprover
                ? `Quotation Approved for ${transporter.transporter_name}`
                : `Quotation Accepted for ${transporter.transporter_name}`,
            );
            axios
              .get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`)
              .then((res) => {
                const enquiryData = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
                if (
                  enquiryData &&
                  autoPushIndent &&
                  autoPushIndent === true &&
                  (!enquiryTransition || enquiryTransition === false) &&
                  !isApprover
                ) {
                  createIndent({ data: { enquiry_lane_details: [enquiryData] } }, item, "accepted");
                }
                setshow(false);


                if (
                  enquiryData &&
                  autoPushIndent &&
                  autoPushIndent === true &&
                  (enquiryTransition ||
                    enquiryTransition === true ||
                    isApprover === true)
                ) {
                  createIndent({ data: { enquiry_lane_details: [enquiryData] } }, item, "approved");
                }
              })
              .catch((err) => {
                setshow(false);
                console.log(err);
              });
          } else {
            toast.error(
              `Quotation Rejected for ${transporter.transporter_name}`,
            );
            axios
              .get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`)
              .then((res) => {
                const enquiryData = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
                setshow(false);

              })
              .catch((err) => {
                setshow(false);
                console.log(err);
              });
          }

          const temp = interestedlist.slice();
          temp.forEach((trans) => {
            if (trans.transporter_id === transporter.transporter_id) {
              trans.rate_list[trans.rate_list.length - 1].bid_status = bidStatus;
            }
          });
          setList(temp);
          fetchSummary();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setshow(false);
      });
  };

  /**
   * Handles the submission of a negotiated rate by a transporter. This function
   * manages user activity logging, event tracking with Mixpanel, rate validation,
   * server updates, and sending notifications via email.
   *
   * @param {Object} transporter - The transporter object containing negotiation details.
   * @param {string} transporter.transporter_name - The name of the transporter.
   * @param {number} transporter.rate - The initial rate provided by the transporter.
   * @param {number} transporter.negotiated_rate - The rate proposed by the company for negotiation.
   * @param {string} [transporter.remark] - Optional remark for the negotiation.
   * @returns {void}
   */
  const submitNegotiatedRate = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }


    // Log user activity
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on negitiate button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label},
        transporter name: ${transporter?.transporter_name}, transporter id: ${transporter?.transporter_id}, transporter rate: ${transporter?.rate}, negotiated rate: ${transporter.negotiated_rate}`,
      Definition: `user clicked on the submit negotiate rate button on an enquiry`,
    });
    // mixpanel.track(`User has clicked on Negotiate button`, {
    //   ApplicationName: `${Urls.mixpanelappname}`,
    //   ScreenName: "LoRRI-Trucksavailable",
    //   ModuleName: "my_enquiries",
    //   ActivityLog: `userClickedNegotiateButton`,
    //   Data: `Lane: ${item.origin.location_name} to ${
    //     item.destination.location_name
    //   }, ${
    //     Array.isArray(item.truck_types) ? (
    //       <>
    //         {" "}
    //         {item.truck_types && item.truck_types.length > 0
    //           ? item.truck_types.map((trucks) => {
    //               return trucks.label;
    //             })
    //           : null}{" "}
    //       </>
    //     ) : (
    //       item.truck_types.label
    //     )
    //   }.\nQuotation negotiated for ${transporter.transporter_name}`,
    //   Definition: `User has clicked on Negitiate button`,
    //   ActivityType: "event_view",
    //   UserName: `${localStorage.getItem("userdetails")}`,
    //   UserEmail: `${localStorage.getItem("useremail")}`,
    //   CompanyName: `${localStorage.getItem("companyname")}`,
    // });

    // Validate the negotiated rate
    if (parseInt(transporter.negotiated_rate) === parseInt(transporter.rate)) {
      toast.info("Rate and Counter Offer cannot be the same");
    } else if (
      transporter.negotiated_rate === "" ||
      transporter.negotiated_rate === undefined ||
      parseInt(transporter.negotiated_rate) < 0 ||
      transporter.negotiated_rate === null ||
      parseInt(transporter.negotiated_rate) === 0
    ) {
      toast.info("Rate and Counter Offer cannot be empty or 0");
    } else {
      let total_rates = total_quotes_count.reduce(
        (sum, t) => sum + t.rate_list_count,
        0,
      );
      var payload = {
        truck_enquiry_id: item.truck_enquiry_id,
        transporter_id: transporter.transporter_id,
        rate: transporter.rate,
        total_quotes_count: total_rates,
        quot_type: transporter.quot_type || null,
        bid_status: "negotiated",
        negotiated_rate: transporter.negotiated_rate,
        remark: transporter.remark || "",
        approver: isApprover,
        mode: "enquiry_level",
      };
      // console.log(payload, '628')
      setshow(true);

      // Update server with negotiated rate
      axios
        .put(
          `${Urls.spot}?edit_bid_status_v2=negotiated&field=logistics_enquiry`,
          payload,
        )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.status &&
            (res.data.status === "update_failed" || res.data.status === "Failed")
          ) {
            setshow(false);
            if (res.data.message === "the client has been updated the rate. Please refresh the page") {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "the client has been updated the rate. Please refresh the page",
                showConfirm: false,
                cancelText: "Close"
              });
            } else if (res.data.message === "Spot has been expired") {
              setRateChangedDialogData({
                title: "Spot Expired",
                message: "Spot has been expired",
                showConfirm: false,
                cancelText: "Close"
              });
            } else {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "The transporter has updated the rate. Please refresh the page to see the latest rate before taking any action.",
                showConfirm: true,
                confirmText: "Refresh Now",
                cancelText: "Cancel"
              });
            }
            setRateChangedDialog(true);
          } else {
            var temp = interestedlist.slice();
            if (temp && temp.length > 0) {
              temp.map((trans) => {
                if (trans.transporter_id === transporter.transporter_id) {
                  trans.rate_list[trans.rate_list.length - 1] = {
                    bid_status: "negotiated",
                    negotiated_rate: transporter.negotiated_rate,
                    negotiated_at: new Date(),
                    rate: transporter.rate,
                    // "bid_status": "negotiated",
                    rate_by: "company",
                    change: true,
                    negotiated_by: localStorage.getItem("userdetails"),
                    negotiated_by_email: localStorage.getItem("useremail"),
                    remark: transporter.remark,
                  };
                }
              });
              setList(temp);
            }
            toast.success(
              `Counter offer quote submitted to ${transporter.transporter_name}`,
            );
            if (onSuccess) onSuccess();

            // Fetch updated transporter list
            fetchSummary();
          }
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }
  };

  /**
   * Cancels a negotiated rate for a transporter. This function updates the list of
   * interested transporters by either marking the rate as changed or removing the
   * negotiated rate from the list based on the current state.
   *
   * @param {Object} transporter - The transporter object whose negotiated rate is to be canceled.
   * @param {string} transporter.transporter_id - The ID of the transporter.
   * @param {Array<Object>} transporter.rate_list - The list of rates for the transporter.
   * @returns {void}
   */
  const cancelnegotiate = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    var temp = interestedlist.slice();

    // Check if the transporter has a negotiated rate and it is not zero
    if (
      transporter.rate_list &&
      transporter.rate_list[transporter.rate_list.length - 1].negotiated_rate &&
      transporter.rate_list[transporter.rate_list.length - 1]
        .negotiated_rate !== 0
    ) {
      // Update the rate list to mark the rate as changed
      if (temp && temp.length) {
        temp.map((trans) => {
          if (trans.transporter_id === transporter.transporter_id) {
            trans.rate_list[trans.rate_list.length - 1].change = true;
          }
        });
        setList(temp);
      }
    } else {
      // Remove the negotiated rate from the list
      if (temp && temp.length) {
        temp.map((trans) => {
          if (trans.transporter_id === transporter.transporter_id) {
            var list = [];
            trans.rate_list.map((val, index) => {
              if (trans.rate_list.length - 1 !== index) {
                list.push(val);
              }
            });
            trans.rate_list = list;
          }
        });
        setList(temp);
      }
    }
  };

  /**
   * Renders the negotiation UI for a transporter, including input fields and buttons
   * for submitting or canceling a counter offer. The UI varies based on whether a
   * negotiated rate has been set and if there have been changes to it.
   *
   * @param {Object} props - The properties passed to the component.
   * @param {Object} props.transporter - The transporter object containing rate information.
   * @param {number} props.index - The index of the transporter in the list.
   * @returns {JSX.Element} The rendered UI component for negotiation.
   */
  const ShowNegotiation = ({ transporter, index }) => {
    return transporter.rate_list[transporter.rate_list.length - 1]
      .negotiated_rate &&
      transporter.rate_list[transporter.rate_list.length - 1].change ? (
      <>
        {/* Display negotiation details when a counter offer has been submitted and changed */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <input
            style={{
              height: "28px",
              margin: "0",
              padding: "0 3px",
              width: "80px",
              textAlign: "center",
            }}
            type="number"
            disabled
            defaultValue={
              transporter.rate_list[transporter.rate_list.length - 1]
                .negotiated_rate
                ? transporter.rate_list[transporter.rate_list.length - 1]
                  .negotiated_rate
                : transporter.rate
            }
          />
          <button
            className={`btn btn-sm btn-primary`}
            style={{
              margin: "0 5%",
              padding: "2% 5%",
              borderRadius: "50%",
              cursor: isRestricted ? "not-allowed" : "pointer",
              opacity: isRestricted ? 0.6 : 1,
            }}
            onClick={(e) => editnegrate(transporter)}
            disabled={item.status?.enquiry_closed === true || isRestricted}
            title={"Edit Negotiated Rate"}
          >
            <i className={"fa fa-edit"} />
          </button>
          <button
            style={{ margin: "0 5%", padding: "2% 5%", borderRadius: "50%" }}
            disabled
            className={`btn btn-sm btn-success`}
            title="Submit Counter Offer"
          >
            <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
          </button>
        </div>
        <div style={{ width: "130%" }}>
          <span
            style={{ color: "orange", fontSize: "10px", fontStyle: "italic" }}
          >
            Counter Offer Submitted
          </span>
        </div>
      </>
    ) : (
      <>
        {/* Display negotiation controls when no counter offer has been submitted or changed */}
        {isMobile() ? (
          ""
        ) : (
          <div style={{ textAlign: "left" }}>Counter Offer:</div>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className={`btn btn-sm btn-primary`}
            onClick={(e) => substractHandler(transporter)}
            title={"-500"}
            style={{
              margin: "0 2%",
              padding: "1% 3%",
              cursor: isEnquiryApproved ? "not-allowed" : "pointer",
              opacity: isEnquiryApproved ? 0.6 : 1
            }}
          >
            <i className={"fa fa-minus-circle"} />
          </button>
          <input
            disabled={isEnquiryApproved}
            id={`transporter${index}`}
            style={{
              height: "28px",
              margin: "0",
              padding: "0 3px",
              width: "80px",
              textAlign: "center",
            }}
            type="text"
            onChange={(e) => inputChangeHandler(e, transporter, index)}
            defaultValue={transporter.negotiated_rate}
          />
          <button
            className={`btn btn-sm btn-primary`}
            onClick={(e) => addHandler(transporter)}
            title={"+500"}
            style={{
              margin: "0 2%",
              padding: "1% 3%",
              cursor: isEnquiryApproved ? "not-allowed" : "pointer",
              opacity: isEnquiryApproved ? 0.6 : 1
            }}
          >
            <i className={"fa fa-plus-circle"} />
          </button>
          <button
            style={{
              margin: "0 1%",
              padding: "1% 5%",
              borderRadius: "50%",
              cursor: isEnquiryApproved ? "not-allowed" : "pointer",
              opacity: isEnquiryApproved ? 0.6 : 1
            }}
            className={`btn btn-sm btn-success`}
            title="Submit Counter Offer"
            onClick={(e) => submitNegotiatedRate(transporter)}
          >
            <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
          </button>
          <button
            onClick={(e) => cancelnegotiate(transporter)}
            style={{
              margin: "0 1%",
              padding: "1% 5%",
              borderRadius: "50%",
              cursor: isEnquiryApproved ? "not-allowed" : "pointer",
              opacity: isEnquiryApproved ? 0.6 : 1
            }}
            className={`btn btn-sm btn-secondary`}
          >
            <i className={`fa fa-times`}></i>
          </button>
        </div>
      </>
    );
  };

  /**
   * Renders the status of a transporter based on their rate list and status. It also provides
   * buttons for accepting, rejecting, or giving a counter offer, as well as remarks.
   *
   * @param {Object} props - The properties passed to the component.
   * @param {Object} props.transporter - The transporter object containing rate and status information.
   * @param {number} props.index - The index of the transporter in the list.
   * @returns {JSX.Element|null} The rendered UI component for displaying transporter status or null if no status is applicable.
   */
  // const GetStatus = ({ transporter, index }) => {
  //   return transporter.rate_list && transporter.rate_list.length > 0 ? (
  //     transporter.main_status === "approved" ||
  //       (transporter.rate_list[transporter.rate_list.length - 1].main_status &&
  //         transporter.rate_list[transporter.rate_list.length - 1].main_status ===
  //         "approved") ||
  //       transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
  //       "approved" ? (
  //       <span style={{ color: "#54a63a" }}>
  //         <i className="fa fa-certificate" /> Approved
  //       </span>
  //     ) : (transporter.main_status === "approval_pending" ||
  //       (transporter.rate_list[transporter.rate_list.length - 1]
  //         .main_status &&
  //         transporter.rate_list[transporter.rate_list.length - 1]
  //           .main_status === "approval_pending")) &&
  //       approval_type !== "bulk" &&
  //       transporter.rate_list[transporter.rate_list.length - 1].bid_status !==
  //       "negotiated" ? (
  //       <>
  //         <span style={{ color: "orange" }}>Approval Pending</span>
  //         <br />
  //         {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
  //           <span style={{ fontStyle: "italic", fontSize: "12px" }}>
  //             Remark:{" "}
  //             {transporter.rate_list[transporter.rate_list.length - 1].remark}
  //           </span>
  //         ) : null}
  //       </>
  //     ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
  //       "accepted" ? (
  //       <>
  //         {transporter.rate_list[transporter.rate_list.length - 1].main_status === "accepted" ? (
  //           <span style={{ color: "#54a63a" }}>Accepted</span>
  //         ) : (
  //           <span style={{ color: "orange" }}>Approval Pending</span>
  //         )}
  //         <br />
  //         {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
  //           <span style={{ fontStyle: "italic", fontSize: "12px" }}>
  //             Remark:{" "}
  //             {transporter.rate_list[transporter.rate_list.length - 1].remark}
  //           </span>
  //         ) : null}
  //       </>
  //     ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
  //       "rejected" ? (
  //       <>
  //         <span style={{ color: "red" }}>Rejected</span>
  //         <br />
  //         {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
  //           <span style={{ fontStyle: "italic", fontSize: "12px" }}>
  //             Remark:{" "}
  //             {transporter.rate_list[transporter.rate_list.length - 1].remark}
  //           </span>
  //         ) : null}
  //       </>
  //     ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
  //       "negotiated" ? (
  //       <ShowNegotiation transporter={transporter} index={index} />
  //     ) : (
  //       <>
  //         {transporter.rate_list[transporter.rate_list.length - 1].transporter_accepted === true ? (
  //           <>
  //           {console.log(isNegotiateAfterNoRegret, 'isNegotiateAfterNoRegret')}
  //             {isNegotiateAfterNoRegret === true? (
  //               // Full set: Accept + Reject + Counter Offer
  //               <>
  //                 <button
  //                   className={"btn btn-sm btn-success"}
  //                   style={{
  //                     margin: isMobile() ? "0 1%" : "1% 5%",
  //                     padding: isMobile() ? "" : "2% 4%",
  //                     borderRadius: isMobile() ? "" : "50%",
  //                     cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                     opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                   }}
  //                   title="Accept"
  //                   disabled={
  //                     itemdisable ||
  //                     isExpiredAcceptanceBlocked ||
  //                     item.status?.enquiry_closed === true ||
  //                     item.indent_created === true ||
  //                     isIndentCreated ||
  //                     isRestricted
  //                   }
  //                   onClick={(e) => acceptrejectHandler(transporter, "accepted")}
  //                 >
  //                   {isMobile() ? "Accept" : !isApprover ? (
  //                     <i className="fa fa-check" />
  //                   ) : (
  //                     <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
  //                   )}
  //                 </button>
  //                 {!isPostExpiryAcceptanceFlow && (
  //                   <button
  //                     className={"btn btn-sm btn-danger"}
  //                     style={{
  //                       margin: isMobile() ? "0 1%" : "1% 5%",
  //                       padding: isMobile() ? "" : "2% 5%",
  //                       borderRadius: isMobile() ? "" : "50%",
  //                       cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                       opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                     }}
  //                     title="Reject"
  //                     disabled={
  //                       itemdisable ||
  //                       item.status?.enquiry_closed === true ||
  //                       item.indent_created === true ||
  //                       isIndentCreated ||
  //                       isRestricted
  //                     }
  //                     onClick={(e) => acceptrejectHandler(transporter, "rejected")}
  //                   >
  //                     {isMobile() ? "Reject" : <i className="fa fa-times" />}
  //                   </button>
  //                 )}
  //                 {!isPostExpiryAcceptanceFlow && (
  //                   <button
  //                     className={"btn btn-sm btn-primary"}
  //                     style={{
  //                       margin: isMobile() ? "0 1%" : "1% 5%",
  //                       padding: isMobile() ? "" : "1.5% 6%",
  //                       borderRadius: isMobile() ? "" : "50%",
  //                       cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                       opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                     }}
  //                     title="Give counter offer"
  //                     disabled={
  //                       itemdisable ||
  //                       item.status?.enquiry_closed === true ||
  //                       item.indent_created === true ||
  //                       isIndentCreated ||
  //                       isRestricted
  //                     }
  //                     onClick={(e) => clickHandler(transporter)}
  //                   >
  //                     {isMobile() ? "Counter Offer" : companySettingData?.default_currency?.default_currency?.symbol ? (
  //                       <span style={{ fontSize: "14px", fontWeight: "bold" }}>
  //                         {companySettingData?.default_currency?.default_currency?.symbol}
  //                       </span>
  //                     ) : (
  //                       <i className="fa fa-inr" />
  //                     )}
  //                   </button>
  //                 )}

  //                 {(isMandatoryApprovalRemark || index !== 0) ? (
  //                   <input
  //                     disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
  //                     type="textarea"
  //                     onChange={(e) => handleInputChange(e, transporter, index)}
  //                     defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
  //                     placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
  //                     style={{
  //                       marginBottom: "4%",
  //                       marginTop: "2%",
  //                       borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
  //                     }}
  //                   />
  //                 ) : null}
  //               </>
  //             ) : (
  //               // Original: only Accept/Approve
  //               <>
  //                 <button
  //                   className={"btn btn-sm btn-success"}
  //                   style={{
  //                     margin: isMobile() ? "0 1%" : "1% 5%",
  //                     padding: isMobile() ? "" : "2% 4%",
  //                     borderRadius: isMobile() ? "" : "50%",
  //                     cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                     opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                   }}
  //                   title="Accept"
  //                   disabled={
  //                     itemdisable ||
  //                     isExpiredAcceptanceBlocked ||
  //                     item.status?.enquiry_closed === true ||
  //                     item.indent_created === true ||
  //                     isIndentCreated ||
  //                     isRestricted
  //                   }
  //                   onClick={(e) => acceptrejectHandler(transporter, "accepted")}
  //                 >
  //                   {isMobile() ? "Accept" : !isApprover ? (
  //                     <i className="fa fa-check" />
  //                   ) : (
  //                     <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
  //                   )}
  //                 </button>

  //                 {!isPostExpiryAcceptanceFlow && (
  //                   <button
  //                     className={"btn btn-sm btn-danger"}
  //                     style={{
  //                       margin: isMobile() ? "0 1%" : "1% 5%",
  //                       padding: isMobile() ? "" : "2% 5%",
  //                       borderRadius: isMobile() ? "" : "50%",
  //                       cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                       opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                     }}
  //                     title="Reject"
  //                     disabled={
  //                       itemdisable ||
  //                       item.status?.enquiry_closed === true ||
  //                       item.indent_created === true ||
  //                       isIndentCreated ||
  //                       isRestricted
  //                     }
  //                     onClick={(e) => acceptrejectHandler(transporter, "rejected")}
  //                   >
  //                     {isMobile() ? "Reject" : <i className="fa fa-times" />}
  //                   </button>
  //                 )}

  //                 {!isPostExpiryAcceptanceFlow && (
  //                   <button
  //                     className={"btn btn-sm btn-primary"}
  //                     style={{
  //                       margin: isMobile() ? "0 1%" : "1% 5%",
  //                       padding: isMobile() ? "" : "1.5% 6%",
  //                       borderRadius: isMobile() ? "" : "50%",
  //                       cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                       opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                     }}
  //                     title="Give counter offer"
  //                     disabled={
  //                       itemdisable ||
  //                       item.status?.enquiry_closed === true ||
  //                       item.indent_created === true ||
  //                       isIndentCreated ||
  //                       isRestricted
  //                     }
  //                     onClick={(e) => clickHandler(transporter)}
  //                   >
  //                     {isMobile() ? "Counter Offer" : companySettingData?.default_currency?.default_currency?.symbol ? (
  //                       <span style={{ fontSize: "14px", fontWeight: "bold" }}>
  //                         {companySettingData?.default_currency?.default_currency?.symbol}
  //                       </span>
  //                     ) : (
  //                       <i className="fa fa-inr" />
  //                     )}
  //                   </button>
  //                 )}

  //                 {(isMandatoryApprovalRemark || index !== 0) ? (
  //                   <input
  //                     disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
  //                     type="textarea"
  //                     onChange={(e) => handleInputChange(e, transporter, index)}
  //                     defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
  //                     placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
  //                     style={{
  //                       marginBottom: "4%",
  //                       marginTop: "2%",
  //                       borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
  //                     }}
  //                   />
  //                 ) : null}
  //               </>
  //             )}
  //           </>
  //         ) : (
  //           <>
  //             <button
  //               className={"btn btn-sm btn-success"}
  //               style={{
  //                 margin: isMobile() ? "0 1%" : "1% 5%",
  //                 padding: isMobile() ? "" : "2% 4%",
  //                 borderRadius: isMobile() ? "" : "50%",
  //                 cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                 opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //               }}
  //               title="Accept"
  //               disabled={
  //                 itemdisable ||
  //                 item.status?.enquiry_closed === true ||
  //                 item.indent_created === true ||
  //                 isIndentCreated ||
  //                 isRestricted
  //               }
  //               onClick={(e) => acceptrejectHandler(transporter, "accepted")}
  //             >
  //               {isMobile() ? (
  //                 "Accept"
  //               ) : !isApprover ? (
  //                 <i className="fa fa-check" />
  //               ) : (
  //                 <i
  //                   className={`fa fa-thumbs-up ${classes["thumb-color"]}`}
  //                 ></i>
  //               )}
  //             </button>
  //             {!isPostExpiryAcceptanceFlow && (
  //               <button
  //                 className={"btn btn-sm btn-danger"}
  //                 style={{
  //                   margin: isMobile() ? "0 1%" : "1% 5%",
  //                   padding: isMobile() ? "" : "2% 5%",
  //                   borderRadius: isMobile() ? "" : "50%",
  //                   cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                   opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //                 }}
  //                 title="Reject"
  //                 disabled={
  //                   itemdisable ||
  //                   isExpiredAcceptanceBlocked ||
  //                   item.status?.enquiry_closed === true ||
  //                   item.indent_created === true ||
  //                   isIndentCreated ||
  //                   isRestricted
  //                 }
  //                 onClick={(e) => acceptrejectHandler(transporter, "rejected")}
  //               >
  //                 {isMobile() ? "Reject" : <i className="fa fa-times" />}
  //               </button>)}
  //             {!isPostExpiryAcceptanceFlow && (<button
  //               className={"btn btn-sm btn-primary"}
  //               style={{
  //                 margin: isMobile() ? "0 1%" : "1% 5%",
  //                 padding: isMobile() ? "" : "1.5% 6%",
  //                 borderRadius: isMobile() ? "" : "50%",
  //                 cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
  //                 opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
  //               }}
  //               title="Give counter offer"
  //               disabled={
  //                 itemdisable ||
  //                 isExpiredAcceptanceBlocked ||
  //                 item.status?.enquiry_closed === true ||
  //                 item.indent_created === true ||
  //                 isIndentCreated ||
  //                 isRestricted
  //               }
  //               onClick={(e) => clickHandler(transporter)}
  //             >
  //               {isMobile() ? (
  //                 "Counter Offer"
  //               ) : companySettingData?.default_currency?.default_currency
  //                 ?.symbol ? (
  //                 <span style={{ fontSize: "14px", fontWeight: "bold" }}>
  //                   {
  //                     companySettingData?.default_currency?.default_currency
  //                       ?.symbol
  //                   }
  //                 </span>
  //               ) : (
  //                 <i className="fa fa-inr" />
  //               )}
  //             </button>)}
  //             {/* When isMandatoryApprovalRemark is ON: show for ALL ranks (red border + mandatory hint for non-L1).
  //                 When OFF: original behaviour — hidden for L1 (index 0) only. */}
  //             {(isMandatoryApprovalRemark || index !== 0) ? (
  //               <input
  //                 disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
  //                 type="textarea"
  //                 onChange={(e) => handleInputChange(e, transporter, index)}
  //                 defaultValue={
  //                   interestedlist[index].remark
  //                     ? interestedlist[index].remark
  //                     : ""
  //                 }
  //                 placeholder={
  //                   isMandatoryApprovalRemark && index !== 0
  //                     ? "Remark is mandatory*"
  //                     : "Add your remark!"
  //                 }
  //                 style={{
  //                   marginBottom: "4%",
  //                   marginTop: "2%",
  //                   borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
  //                 }}
  //               />
  //             ) : null}
  //           </>
  //         )}
  //       </>
  //     )
  //   ) : null;
  // };

  const GetStatus = ({ transporter, index }) => {
    return transporter.rate_list && transporter.rate_list.length > 0 ? (
      transporter.main_status === "approved" ||
        (transporter.rate_list[transporter.rate_list.length - 1].main_status &&
          transporter.rate_list[transporter.rate_list.length - 1].main_status ===
          "approved") ||
        transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
        "approved" ? (
        <span style={{ color: "#54a63a" }}>
          <i className="fa fa-certificate" /> Approved
        </span>
      ) : (transporter.main_status === "approval_pending" ||
        (transporter.rate_list[transporter.rate_list.length - 1]
          .main_status &&
          transporter.rate_list[transporter.rate_list.length - 1]
            .main_status === "approval_pending")) &&
        approval_type !== "bulk" &&
        transporter.rate_list[transporter.rate_list.length - 1].bid_status !==
        "negotiated" ? (
        <>
          <span style={{ color: "orange" }}>Approval Pending</span>
          <br />
          {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>
              Remark:{" "}
              {transporter.rate_list[transporter.rate_list.length - 1].remark}
            </span>
          ) : null}
        </>
      ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
        "accepted" ? (
        <>
          {transporter.rate_list[transporter.rate_list.length - 1].main_status === "accepted" ? (
            <span style={{ color: "#54a63a" }}>Accepted</span>
          ) : (
            <span style={{ color: "orange" }}>Approval Pending</span>
          )}
          <br />
          {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>
              Remark:{" "}
              {transporter.rate_list[transporter.rate_list.length - 1].remark}
            </span>
          ) : null}
        </>
      ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
        "rejected" ? (
        <>
          <span style={{ color: "red" }}>Rejected</span>
          <br />
          {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>
              Remark:{" "}
              {transporter.rate_list[transporter.rate_list.length - 1].remark}
            </span>
          ) : null}
        </>
      ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
        "negotiated" ? (
        <ShowNegotiation transporter={transporter} index={index} />
      ) : (
        <>
          {transporter.rate_list[transporter.rate_list.length - 1].transporter_accepted === true ? (
            <>
              {isNegotiateAfterNoRegret === true ? (
                // Full set: Accept + Reject + Counter Offer
                <>
                  <button
                    className={"btn btn-sm btn-success"}
                    style={{
                      margin: isMobile() ? "0 1%" : "1% 5%",
                      padding: isMobile() ? "" : "2% 4%",
                      borderRadius: isMobile() ? "" : "50%",
                      cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                      opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                    }}
                    title="Accept"
                    disabled={
                      itemdisable ||
                      isExpiredAcceptanceBlocked ||
                      item.status?.enquiry_closed === true ||
                      item.indent_created === true ||
                      isIndentCreated ||
                      isRestricted
                    }
                    onClick={(e) => acceptrejectHandler(transporter, "accepted")}
                  >
                    {isMobile() ? "Accept" : !isApprover ? (
                      <i className="fa fa-check" />
                    ) : (
                      <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
                    )}
                  </button>
                  {!isPostExpiryAcceptanceFlow && (
                    <button
                      className={"btn btn-sm btn-danger"}
                      style={{
                        margin: isMobile() ? "0 1%" : "1% 5%",
                        padding: isMobile() ? "" : "2% 5%",
                        borderRadius: isMobile() ? "" : "50%",
                        cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                        opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                      }}
                      title="Reject"
                      disabled={
                        itemdisable ||
                        item.status?.enquiry_closed === true ||
                        item.indent_created === true ||
                        isIndentCreated ||
                        isRestricted
                      }
                      onClick={(e) => acceptrejectHandler(transporter, "rejected")}
                    >
                      {isMobile() ? "Reject" : <i className="fa fa-times" />}
                    </button>
                  )}
                  {!isPostExpiryAcceptanceFlow && (
                    <button
                      className={"btn btn-sm btn-primary"}
                      style={{
                        margin: isMobile() ? "0 1%" : "1% 5%",
                        padding: isMobile() ? "" : "1.5% 6%",
                        borderRadius: isMobile() ? "" : "50%",
                        cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                        opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                      }}
                      title="Give counter offer"
                      disabled={
                        itemdisable ||
                        item.status?.enquiry_closed === true ||
                        item.indent_created === true ||
                        isIndentCreated ||
                        isRestricted
                      }
                      onClick={(e) => clickHandler(transporter)}
                    >
                      {isMobile() ? "Counter Offer" : companySettingData?.default_currency?.default_currency?.symbol ? (
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                          {companySettingData?.default_currency?.default_currency?.symbol}
                        </span>
                      ) : (
                        <i className="fa fa-inr" />
                      )}
                    </button>
                  )}
                  {(isMandatoryApprovalRemark || index !== 0) ? (
                    <input
                      disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
                      type="textarea"
                      onChange={(e) => handleInputChange(e, transporter, index)}
                      defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
                      placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
                      style={{
                        marginBottom: "4%",
                        marginTop: "2%",
                        borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
                      }}
                    />
                  ) : null}
                </>
              ) : (
                // Original: only Accept/Approve — NO reject, NO counter offer
                <>
                  <button
                    className={"btn btn-sm btn-success"}
                    style={{
                      margin: isMobile() ? "0 1%" : "1% 5%",
                      padding: isMobile() ? "" : "2% 4%",
                      borderRadius: isMobile() ? "" : "50%",
                      cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                      opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                    }}
                    title="Accept"
                    disabled={
                      itemdisable ||
                      isExpiredAcceptanceBlocked ||
                      item.status?.enquiry_closed === true ||
                      item.indent_created === true ||
                      isIndentCreated ||
                      isRestricted
                    }
                    onClick={(e) => acceptrejectHandler(transporter, "accepted")}
                  >
                    {isMobile() ? "Accept" : !isApprover ? (
                      <i className="fa fa-check" />
                    ) : (
                      <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
                    )}
                  </button>
                  <br />
                  <span style={{ color: "#393185", fontSize: "11px", fontStyle: "italic" }}>
                    Note: {transporter.transporter_name} has Accepted your <b>Counter Offer</b>,{" "}
                    {isApprover
                      ? "Kindly click above button to Approve the rate"
                      : "Kindly click above button to request approval"}
                  </span>
                  {(isMandatoryApprovalRemark || index !== 0) ? (
                    <input
                      disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
                      type="textarea"
                      onChange={(e) => handleInputChange(e, transporter, index)}
                      defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
                      placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
                      style={{
                        marginBottom: "4%",
                        marginTop: "2%",
                        borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
                      }}
                    />
                  ) : null}
                </>
              )}
            </>
          ) : (
            <>
              <button
                className={"btn btn-sm btn-success"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 4%",
                  borderRadius: isMobile() ? "" : "50%",
                  cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                  opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                }}
                title="Accept"
                disabled={
                  itemdisable ||
                  item.status?.enquiry_closed === true ||
                  item.indent_created === true ||
                  isIndentCreated ||
                  isRestricted
                }
                onClick={(e) => acceptrejectHandler(transporter, "accepted")}
              >
                {isMobile() ? (
                  "Accept"
                ) : !isApprover ? (
                  <i className="fa fa-check" />
                ) : (
                  <i
                    className={`fa fa-thumbs-up ${classes["thumb-color"]}`}
                  ></i>
                )}
              </button>
              {!isPostExpiryAcceptanceFlow && (
                <button
                  className={"btn btn-sm btn-danger"}
                  style={{
                    margin: isMobile() ? "0 1%" : "1% 5%",
                    padding: isMobile() ? "" : "2% 5%",
                    borderRadius: isMobile() ? "" : "50%",
                    cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                    opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                  }}
                  title="Reject"
                  disabled={
                    itemdisable ||
                    isExpiredAcceptanceBlocked ||
                    item.status?.enquiry_closed === true ||
                    item.indent_created === true ||
                    isIndentCreated ||
                    isRestricted
                  }
                  onClick={(e) => acceptrejectHandler(transporter, "rejected")}
                >
                  {isMobile() ? "Reject" : <i className="fa fa-times" />}
                </button>)}
              {!isPostExpiryAcceptanceFlow && (<button
                className={"btn btn-sm btn-primary"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "1.5% 6%",
                  borderRadius: isMobile() ? "" : "50%",
                  cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                  opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                }}
                title="Give counter offer"
                disabled={
                  itemdisable ||
                  isExpiredAcceptanceBlocked ||
                  item.status?.enquiry_closed === true ||
                  item.indent_created === true ||
                  isIndentCreated ||
                  isRestricted
                }
                onClick={(e) => clickHandler(transporter)}
              >
                {isMobile() ? (
                  "Counter Offer"
                ) : companySettingData?.default_currency?.default_currency
                  ?.symbol ? (
                  <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {
                      companySettingData?.default_currency?.default_currency
                        ?.symbol
                    }
                  </span>
                ) : (
                  <i className="fa fa-inr" />
                )}
              </button>)}
              {/* When isMandatoryApprovalRemark is ON: show for ALL ranks (red border + mandatory hint for non-L1).
                  When OFF: original behaviour — hidden for L1 (index 0) only. */}
              {(isMandatoryApprovalRemark || index !== 0) ? (
                <input
                  disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
                  type="textarea"
                  onChange={(e) => handleInputChange(e, transporter, index)}
                  defaultValue={
                    interestedlist[index].remark
                      ? interestedlist[index].remark
                      : ""
                  }
                  placeholder={
                    isMandatoryApprovalRemark && index !== 0
                      ? "Remark is mandatory*"
                      : "Add your remark!"
                  }
                  style={{
                    marginBottom: "4%",
                    marginTop: "2%",
                    borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
                  }}
                />
              ) : null}
            </>
          )}
        </>
      )
    ) : null;
  };
  /**
   * Toggles the visibility of the history for a specific transporter in the interested list.
   *
   * @param {Object} history_for_transporter - The transporter object for which history visibility is to be toggled.
   * @param {string} history_for_transporter.transporter_id - The unique identifier of the transporter whose history is being toggled.
   */
  const showHistory = (history_for_transporter) => {
    const transporterList = interestedlist.map((transporter) => {
      if (
        transporter.transporter_id === history_for_transporter.transporter_id
      ) {
        transporter.show_history = !transporter.show_history;
      }
      return transporter;
    });
    // console.log(transporter_list)
    setList(transporterList);
  };

  /**
   * Retrieves the lowest bid from the list of interested transporters.
   *
   * @returns {string|number} The lowest bid from the interested list, or `'--'` if no rates are available.
   */
  const getLowestBid = () => {
    const hasRate = interestedlist.filter(
      (l) => l.rate !== undefined && l.rate !== null,
    );
    if (hasRate.length === 0) {
      return "--";
    }

    const lowestRate = Math.min(
      ...hasRate.map((item) => parseFloat(item.rate)),
    );
    return lowestRate;
  };
  const handleClose = () => {
    setErrorInAcceptance(false);
  };

  return (
    <>
      <Loader show={show} />

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={() => setConfirmDialog(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        confirmText={confirmDialog.confirmText}
        variant={confirmDialog.variant}
      />

      <ConfirmDialog
        isOpen={rateChangedDialog}
        onClose={() => setRateChangedDialog(false)}
        onConfirm={() => {
          setRateChangedDialog(false);
          fetchSummary();
        }}
        title={rateChangedDialogData.title}
        message={
          <span>
            <i className="fa fa-exclamation-triangle" style={{ color: '#e74a3b', marginRight: '8px' }} />
            {rateChangedDialogData.message}
          </span>
        }
        confirmText={rateChangedDialogData.confirmText || "Refresh Now"}
        cancelText={rateChangedDialogData.cancelText || "Cancel"}
        showConfirm={rateChangedDialogData.showConfirm}
        variant="warning"
        closeOnEscape={false}
      />

      {newtransporter_list &&
        newtransporter_list !== undefined &&
        newtransporter_list.length > 0 ? (
        <>
          <div className="row" style={{ marginBottom: "16px", alignItems: "stretch" }}>
            <div className="col-md-7">
              <div style={{ marginBottom: "12px" }}>
                <CountdownTimer
                  expiry_date={item.expiry_date}
                  isExpired={item.status?.is_expired}
                  isDelete={item.status?.is_deleted}
                  ApprovedStatus={item.status?.approved_status}
                  enquiry_closed={item.status?.enquiry_closed}
                  ScreenName="my enquiries - quotation summary"
                />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'stretch' }}>
                {/* Responses Card */}
                <div style={{ flex: 1, background: '#fff', borderRadius: '10px', border: '1px solid #e3e6f0', borderLeft: '4px solid #393185', padding: '12px 14px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '76px', boxShadow: '0 2px 6px rgba(57,49,133,0.07)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
                    <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#ebe9f8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-users" style={{ fontSize: '9px', color: '#393185' }} />
                    </span>
                    <span style={{ fontSize: '9px', color: '#858796', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.6px' }}>Responses</span>
                  </div>
                  <div style={{ fontSize: '26px', fontWeight: '800', color: '#393185', lineHeight: 1 }}>{interestedlist.length}</div>
                </div>
                {/* L1 Rate Card */}
                <div style={{ flex: 1, background: '#fff', borderRadius: '10px', border: '1px solid #e3e6f0', borderLeft: '4px solid #54AF3A', padding: '12px 14px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '76px', boxShadow: '0 2px 6px rgba(28,200,138,0.07)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
                    <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#eafbe3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-trophy" style={{ fontSize: '9px', color: '#54AF3A' }} />
                    </span>
                    <span style={{ fontSize: '9px', color: '#858796', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.6px' }}>Lowest Quote (L1)</span>
                  </div>
                  <div style={{ fontSize: '26px', fontWeight: '800', color: '#54AF3A', lineHeight: 1 }}>
                    {interestedlist && interestedlist.length > 0 ? (getLowestBid() !== "--" ? Number(getLowestBid()).toLocaleString('en-IN') : "--") : "--"}
                  </div>
                </div>
                {/* L1 Transporter Card */}
                <div style={{ flex: 1, background: '#fff', borderRadius: '10px', border: '1px solid #e3e6f0', borderLeft: '4px solid #4e73df', padding: '12px 14px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '76px', boxShadow: '0 2px 6px rgba(78,115,223,0.07)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
                    <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#eaeffc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-truck" style={{ fontSize: '9px', color: '#4e73df' }} />
                    </span>
                    <span style={{ fontSize: '9px', color: '#858796', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.6px' }}>L1 Transporter</span>
                  </div>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#4e73df', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.2 }}>
                    {interestedlist.length > 0 ? (() => {
                      const transporterWithLowestRate = interestedlist.reduce((minTransporter, currentTransporter) => {
                        const currentRate = parseFloat(currentTransporter.rate);
                        const minRate = parseFloat(minTransporter.rate);
                        if (!isNaN(currentRate) && (isNaN(minRate) || currentRate < minRate)) {
                          return currentTransporter;
                        }
                        return minTransporter;
                      }, "--");
                      return (
                        <ProfileModal
                          buttonClass={`btn-link p-0 m-0`}
                          style={{ fontSize: '13px', fontWeight: '700' }}
                          transporter_list={interestedlist}
                          transporter_name={transporterWithLowestRate.transporter_name}
                          transporter_id={transporterWithLowestRate.transporter_id}
                          screenName={"LoRRI Adhoc"}
                          moduleName={"My Enquiries"}
                        />
                      );
                    })() : "--"}
                  </div>
                </div>
              </div>
              {/* {isIndentCreated || item.indent_created === true ? (
                <div style={{ marginTop: "12px", padding: "9px 12px", background: "#e8f5e9", color: "#2e7d32", borderRadius: "8px", border: "1px solid #c8e6c9", fontWeight: "600", fontSize: "13px", display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fa fa-check-circle" style={{ color: '#4caf50' }} /> Indent has been created for this enquiry
                </div>
              ) : item.status?.enquiry_closed === true ? (
                <div style={{ marginTop: "12px", padding: "9px 12px", background: "#fff8e1", color: "#795700", borderRadius: "8px", border: "1px solid #ffe082", fontWeight: "600", fontSize: "13px", display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fa fa-exclamation-triangle" style={{ color: '#f59e0b' }} /> This enquiry is closed
                </div>
              ) : null} */}
              {isIndentCreated || item.indent_created === true ? (
                <div
                  style={{
                    marginTop: "12px",
                    padding: "9px 12px",
                    background: "#e8f5e9",
                    color: "#2e7d32",
                    borderRadius: "8px",
                    border: "1px solid #c8e6c9",
                    fontWeight: "600",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-check-circle" style={{ color: "#4caf50" }} />
                  Indent has been created for this enquiry
                </div>
              ) : item.status?.is_expired === true ? (
                <div
                  style={{
                    marginTop: "12px",
                    padding: "9px 12px",
                    background: "#fdecea",
                    color: "#a94442",
                    borderRadius: "8px",
                    border: "1px solid #f5c2c7",
                    fontWeight: "600",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-clock-o" style={{ color: "#e74a3b" }} />
                  This enquiry is expired
                </div>
              ) : item.status?.enquiry_closed === true ? (
                <div
                  style={{
                    marginTop: "12px",
                    padding: "9px 12px",
                    background: "#fff8e1",
                    color: "#795700",
                    borderRadius: "8px",
                    border: "1px solid #ffe082",
                    fontWeight: "600",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-exclamation-triangle" style={{ color: "#f59e0b" }} />
                  This enquiry is closed
                </div>
              ) : null}
            </div>
            {isMobile() ? null : (
              <div className="col-md-5">
                <div style={{ background: '#fff', padding: '8px 10px', borderRadius: '10px', border: '1px solid #e3e6f0', height: '100%', boxShadow: '0 2px 6px rgba(0,0,0,0.04)' }}>
                  <div style={{ fontSize: '8.5px', fontWeight: '800', color: '#393185', textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.8px', borderBottom: '1px solid #f0f0f0', paddingBottom: '4px' }}>
                    <i className="fa fa-info-circle" style={{ marginRight: '5px', opacity: 0.6 }} />Legend
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px' }}>
                    {[
                      { icon: !isApprover ? "fa fa-check" : "fa fa-thumbs-up", color: '#1cc88a', bg: '#e6faf3', label: !isApprover ? (approval_type === "bulk" ? "Accept" : "Request Approval") : "Approve" },
                      { icon: "fa fa-times", color: '#e74a3b', bg: '#fdecea', label: "Reject" },
                      { icon: "fa fa-tag", color: '#4e73df', bg: '#eaeffc', label: "Negotiated" },
                      { icon: null, isSymbol: true, color: '#4e73df', bg: '#eaeffc', label: "Counter Offer" },
                      { icon: "fa fa-history", color: '#36b9cc', bg: '#e3f8fc', label: "History" },
                      { icon: "fa fa-dot-circle-o", color: '#1cc88a', bg: '#e6faf3', label: "Final Negotiated" },
                    ].map((item2, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '10px', color: '#5a5c69', fontWeight: '500' }}>
                        <span style={{ width: '18px', height: '18px', borderRadius: '4px', background: item2.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          {item2.isSymbol
                            ? <span style={{ fontSize: '9px', fontWeight: 'bold', color: item2.color }}>{companySettingData?.default_currency?.default_currency?.symbol ?? <i className="fa fa-inr" />}</span>
                            : <i className={item2.icon} style={{ fontSize: '9px', color: item2.color }} />
                          }
                        </span>
                        {item2.label}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
            <AlertPopup
              show={errorInAcceptance}
              isClosable={true}
              onClose={handleClose}
              withHeader={true}
              headerTitle="You might have received New Quotes"
              closeOnEscape={false}
              contentClassName="p-5"
              closeButtonClassName="btn btn-sm text-muted"
              isCancelButtonRequired={true}
              cancelButtonContent="Proceed with Existing"
              acceptButtonContent="Review"
              isAcceptButtonRequired={true}
              onAcceptClick={() => {
                fetchSummary();
                setErrorInAcceptance(false);
              }}
              onCancelClick={() => {
                acceptrejectHandler(
                  acceptedRejectedData.transporter,
                  acceptedRejectedData.value,
                  false,
                );
                setErrorInAcceptance(false);
              }}
            >
              <div style={{ width: "92%" }}>
                Please Click on <b>Review</b> to check new quotes or{" "}
                <b>Proceed with Existing</b>.
              </div>
            </AlertPopup>
            {isMobile() ? (
              <div>
                {interestedlist && interestedlist.length > 0
                  ? interestedlist.map((tl, index) => {
                    return (
                      <div className={classes["mob-transporter"]}>
                        <div>
                          <b>Rank: </b>
                          {rank_list && rank_list.length > 0
                            ? rank_list.map((rank, i) => {
                              if (rank === parseInt(tl.rate)) {
                                return <span>{i + 1}</span>;
                              }
                            })
                            : null}
                        </div>
                        <div>
                          <b>Transporter Name</b>
                          {tl.transporter_name ? (
                            // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(tl.transporter_name)}</a>
                            <ProfileModal
                              transporter_id={tl.transporter_id}
                              transporter_name={tl.transporter_name}
                              screenName={"LoRRI Adhoc"}
                              moduleName={"My Enquiries"}
                            />
                          ) : (
                            item?.benchmark_transporter_list?.map((val) => {
                              if (val.transporter_id === tl.transporter_id) {
                                return (
                                  <ProfileModal
                                    transporter_list={interestedlist}
                                    transporter_id={val.transporter_id}
                                    transporter_name={val.transporter_name}
                                    screenName={"LoRRI Adhoc"}
                                    moduleName={"My Enquiries"}
                                  />
                                );
                                // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(val.transporter_name)}</a>
                              }
                            })
                          )}
                        </div>
                        <div>
                          <b>Rate: </b>
                          {tl.rate ? Number(tl.rate).toLocaleString('en-IN') : tl.rate}
                          {(tl.quot_type === "counter_offer_quote" ||
                            tl.quot_type === "quote_after_rejection") &&
                            tl.rate_list[tl.rate_list.length - 1].bid_status !==
                            "accepted" ? (
                            <i className={`fa fa-tag`} />
                          ) : null}
                        </div>
                        <div>
                          <b>Timestamp: </b>
                          {tl.rate_submission_date
                            ? NegotiateDateFormatter(tl.rate_submission_date)
                            : null}
                        </div>
                        <div>
                          <b>Interest Status: </b>
                          {tl.interest_data && tl.interest_data.length > 0
                            ? tl.interest_data[tl.interest_data.length - 1]
                              .interest_status === "not_interested"
                              ? "Not Interested"
                              : tl.interest_data[tl.interest_data.length - 1]
                                .interest_status === "Interested"
                                ? "Interested"
                                : tl.interest_data[
                                  tl.interest_data.length - 1
                                ].interest_status === "not_operating"
                                  ? "Do Not Operate"
                                  : "Interested"
                            : "Interested"}
                        </div>
                        <div>
                          <div>
                            {tl.rate_list && tl.rate_list.length > 0 ? (
                              <div style={{ margin: "0" }}>
                                <div>
                                  <b>Status: </b>
                                </div>
                                <GetStatus transporter={tl} index={index} />
                              </div>
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            style={{ width: isMobile() ? "250px" : "600px" }}
                          >
                            <div style={{ display: "flex", margin: "3% 0" }}>
                              <div>
                                <b>History:</b>
                              </div>
                              {/* <button className={`btn btn-sm btn-secondary`} style= {{float:'right', marginTop:'-3%',padding:'1px 4px'}} onClick={e => showHistory(tl)}><i className="fa fa-arrow-left" />Back</button> */}
                              <button
                                className={`btn btn-sm btn-info`}
                                style={{
                                  margin: isMobile() ? "" : "1% 5%",
                                  padding: isMobile() ? "0 1%" : "10% 20%",
                                  borderRadius: isMobile() ? "" : "50%",
                                }}
                                onClick={(e) => showHistory(tl)}
                              >
                                <i className={`fa fa-history`} />
                              </button>
                            </div>
                            {tl.show_history ? (
                              <div>
                                <Timeline
                                  rate_list={tl.rate_list}
                                  enquiry={item}
                                  index={index}
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    );
                  })
                  : null}
              </div>
            ) : (
              <div style={{ borderRadius: "8px", border: "1px solid #e3e6f0", marginTop: "15px" }}>
                <table className="table table-hover mb-0" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <thead style={{ background: "#f8f9fc", color: "#5a5c69", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #e3e6f0" }}>
                    <tr>
                      <th style={{ width: "5%", textAlign: "center" }}>Rank</th>
                      <th style={{ width: "25%", paddingLeft: "2%" }}>
                        Transporter Name
                      </th>
                      <th style={{ width: "12%", textAlign: "center" }}>
                        Quotation{" "}
                        {companySettingData?.default_currency?.default_currency
                          ?.symbol ?? <i className="fa fa-inr" />}
                        <i
                          className={"fa fa-info-circle"}
                          data-tip
                          data-for={"desc1"}
                          style={{ margin: "0 2%" }}
                        ></i>
                        <ReactTooltip
                          id="desc1"
                          place="top"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          <span>
                            <i className="fa fa-tag" /> - Negotiated Rate
                          </span>
                          <br />
                          <span>
                            <i
                              className="fa fa-dot-circle-o"
                              style={{ color: "black" }}
                            />{" "}
                            - No Regret Offer : Final Negotiated Rate by
                            Transporter{" "}
                          </span>
                          <br />
                          <span>
                            <i
                              className="fa fa-gavel"
                              style={{ color: "black" }}
                            />{" "}
                            - New Quote{" "}
                          </span>
                        </ReactTooltip>
                      </th>
                      <th style={{ width: "25%", paddingLeft: "7%" }}>
                        Bid Status
                        <i
                          className={"fa fa-info-circle"}
                          data-tip
                          data-for={"desc"}
                          style={{ margin: "0 2%" }}
                        ></i>
                        <ReactTooltip
                          id="desc"
                          place="top"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          <span>
                            <i className="fa fa-check" /> - Accepted
                          </span>
                          <br />
                          <span>
                            <i className="fa fa-times" style={{ color: "red" }} />{" "}
                            - Rejected
                          </span>
                          <br />
                          <span>
                            {/* <i className="fa fa-inr" />  */}
                            {companySettingData?.default_currency
                              ?.default_currency?.symbol ? (
                              <span
                                style={{ fontSize: "13px", fontWeight: "bold" }}
                              >
                                {
                                  companySettingData?.default_currency
                                    ?.default_currency?.symbol
                                }
                              </span>
                            ) : (
                              <i className="fa fa-inr" />
                            )}
                            - Negotiate
                          </span>
                          <br />
                          <span>
                            <i className="fa fa-history" /> - History
                          </span>
                          <br />
                        </ReactTooltip>
                      </th>
                      <th style={{ width: "15%", textAlign: "center" }}>
                        Timestamp
                      </th>
                      <th style={{ width: "10%", textAlign: "center" }}>
                        Status
                      </th>
                      {/* <th style={{ width: "15%", textAlign: "center" }}>POC Number</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {interestedlist && interestedlist.length > 0
                      ? interestedlist
                        .sort((a, b) => {
                          if (!a.rate && !b.rate) return 0;
                          if (!a.rate) return 1;
                          if (!b.rate) return -1;
                          return parseFloat(a.rate) - parseFloat(b.rate);
                        })
                        .map((tl, index) => {
                          const rank =
                            tl.rate && parseFloat(tl.rate) > 0
                              ? index + 1
                              : null;
                          const updateInfo = updatedRateList.find(
                            (u) => u.transporter_id === tl.transporter_id,
                          );
                          const hasNewUpdates =
                            updateInfo?.new_updates === true;
                          return (
                            <React.Fragment key={index}>
                              <tr style={{ verticalAlign: 'middle' }}>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  {rank !== null ? <span>{rank}</span> : null}
                                </td>
                                <td>
                                  {tl.transporter_name ? (
                                    <ProfileModal
                                      transporter_list={interestedlist}
                                      transporter_id={tl.transporter_id}
                                      transporter_name={tl.transporter_name}
                                      screenName={"LoRRI Adhoc"}
                                      moduleName={"My Enquiries"}
                                    />
                                  ) : (
                                    item?.benchmark_transporter_list?.map((val) => {
                                      if (
                                        val.transporter_id === tl.transporter_id
                                      ) {
                                        return (
                                          <ProfileModal
                                            transporter_list={interestedlist}
                                            transporter_id={tl.transporter_id}
                                            transporter_name={tl.transporter_name}
                                            screenName={"LoRRI Adhoc"}
                                            moduleName={"My Enquiries"}
                                          />
                                        );
                                      }
                                    })
                                  )}
                                </td>
                                <td
                                  style={{
                                    maxWidth: "8vw",
                                    wordWrap: "break-word",
                                  }}
                                  data-tip
                                  data-for={
                                    (tl.quot_type === "counter_offer_quote" ||
                                      tl.quot_type ===
                                      "quote_after_rejection") &&
                                      tl.rate_list &&
                                      tl.rate_list.length > 0 &&
                                      tl.rate_list[tl.rate_list.length - 1]
                                        .bid_status !== "accepted"
                                      ? "negotiated-rate"
                                      : tl.rate_list &&
                                        tl.rate_list.length > 0 &&
                                        tl.rate_list[
                                          tl.rate_list.length - 1
                                        ].no_regret_offer === true
                                        ? "final-negotiated-rate"
                                        : null
                                  }
                                >
                                  <span style={{ marginRight: "6%" }}>
                                    {tl.rate ? Number(tl.rate).toLocaleString('en-IN') : tl.rate}
                                  </span>
                                  {(tl.quot_type === "counter_offer_quote" ||
                                    tl.quot_type ===
                                    "quote_after_rejection") &&
                                    tl.rate_list &&
                                    tl.rate_list.length > 0 &&
                                    tl.rate_list[tl.rate_list.length - 1]
                                      .bid_status !== "accepted" ? (
                                    <>
                                      <i
                                        className={`fa fa-tag`}
                                        style={{
                                          cursor: "pointer",
                                          color: "black",
                                        }}
                                        data-tip
                                        data-for={"negotiate-rate"}
                                      />
                                      <ReactTooltip
                                        id="negotiate-rate"
                                        place="bottom"
                                        effect="float"
                                        backgroundColor="#393185 !important"
                                      >
                                        Negotiated Rate
                                      </ReactTooltip>
                                    </>
                                  ) : null}
                                  {tl.rate_list &&
                                    tl.rate_list.length > 0 &&
                                    tl.rate_list[tl.rate_list.length - 1]
                                      .no_regret_offer === true ? (
                                    <>
                                      <i
                                        className="fa fa-dot-circle-o"
                                        style={{
                                          color: "black",
                                          cursor: "pointer",
                                        }}
                                        data-tip
                                        data-for={"final-negotiated-rate"}
                                        aria-hidden="true"
                                      ></i>
                                      <ReactTooltip
                                        id="final-negotiated-rate"
                                        place="bottom"
                                        effect="float"
                                        backgroundColor="#393185 !important"
                                      >
                                        Final Negotiated Rate by Transporter
                                      </ReactTooltip>
                                    </>
                                  ) : null}
                                  {hasNewUpdates &&
                                    hasNewUpdates === true && (
                                      <>
                                        <i
                                          className="fa fa-gavel"
                                          style={{
                                            color: "forestgreen",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                          }}
                                          data-tip
                                          data-for={"new-quote"}
                                          aria-hidden="true"
                                        ></i>
                                        <ReactTooltip
                                          id="new-quote"
                                          place="bottom"
                                          effect="float"
                                          backgroundColor="#393185 !important"
                                        >
                                          New Quote
                                        </ReactTooltip>
                                      </>
                                    )}
                                </td>
                                <td>
                                  {tl.rate_list && tl.rate_list.length > 0 ? (
                                    <div
                                      className={`row`}
                                      style={{ margin: "0" }}
                                    >
                                      <div className={`col-md-9`}>
                                        <GetStatus
                                          transporter={tl}
                                          index={index}
                                        />
                                      </div>
                                      <div className={`col-md-3`}>
                                        <button
                                          className={`btn btn-sm btn-info`}
                                          style={{
                                            margin: "1% 5%",
                                            padding: "10% 20%",
                                            borderRadius: "50%",
                                          }}
                                          onClick={(e) => showHistory(tl)}
                                        >
                                          <i className={`fa fa-history`} />
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {tl.rate_submission_date
                                    ? NegotiateDateFormatter(
                                      tl.rate_submission_date,
                                    )
                                    : null}
                                </td>
                                <td>
                                  {tl.rate
                                    ? "Quoted"
                                    : tl.interest_data &&
                                      tl.interest_data.length > 0
                                      ? tl.interest_data[
                                        tl.interest_data.length - 1
                                      ].interest_status === "not_interested"
                                        ? "Not Interested"
                                        : tl.interest_data[
                                          tl.interest_data.length - 1
                                        ].interest_status === "Interested"
                                          ? "Interested"
                                          : tl.interest_data[
                                            tl.interest_data.length - 1
                                          ].interest_status ===
                                            "not_operating"
                                            ? "Do Not Operate"
                                            : "Interested"
                                      : "Interested"}
                                </td>
                              </tr>
                              {tl.show_history && (
                                <tr>
                                  <td
                                    colSpan="6"
                                    style={{ padding: "0", maxWidth: "0", overflow: "visible" }}
                                  >
                                    <div style={{ background: "#f8f9fc", borderBottom: "2px solid #393185", borderTop: "1px solid #e3e6f0", padding: "12px 16px" }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#393185', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                          <i className="fa fa-history" style={{ marginRight: '6px' }} />
                                          Timeline History
                                        </div>
                                        <button
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() => showHistory(tl)}
                                          style={{ fontSize: '11px', fontWeight: 'bold', padding: '2px 8px' }}
                                        >
                                          <i className="fa fa-times" style={{ marginRight: '4px' }} /> Close
                                        </button>
                                      </div>
                                      <Timeline
                                        rate_list={tl.rate_list}
                                        enquiry={item}
                                        index={index}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      ) : (
        <span>No Data Found</span>
      )}
    </>
  );
};

export default Summary;
